/**
 * @param type
 * @internal
 */
export const isInteger = (type) => {
    return [
        '__int4',
        '__int8',
        'int',
        'tinyint',
        'bigint',
        'int2',
        'int4',
        'int8',
        'smallint',
        'mediumint',
        'serial',
        'integer',
        'byteint',
        'int64',
    ].includes(type.toLowerCase());
};
/**
 * @param type
 * @internal
 */
export const isDecimal = (type) => {
    return [
        'basemeasure',
        'calculatedmeasure',
        'float',
        'float4',
        'float8',
        'double precision',
        'double',
        'numeric',
        'decimal',
        'real',
        'number',
        'float64',
    ].includes(type.toLowerCase());
};
/**
 * @param type
 * @internal
 */
export const isNumber = (type) => {
    return isInteger(type) || isDecimal(type) || type === 'numeric-attribute';
};
/**
 * @param type
 * @internal
 */
export const isText = (type) => {
    return [
        'textdimension',
        'string',
        'varchar',
        'text',
        'ntext',
        'char',
        'character',
        'character varying',
        'smalltext',
        'nchar',
        'nvarchar',
        'json',
        'jsonb',
        'object',
        'text-attribute',
    ].includes(type.toLowerCase());
};
/**
 * @param type
 * @internal
 */
export const isDatetime = (type) => {
    return [
        'datelevel',
        'date',
        'time',
        'datetime',
        'timestamp without time zone',
        'timestamp',
        'timestamp with time zone',
        'timestamp(6)',
        'timestamp_tz',
        'timestamp_ntz',
        'timestamp_ltz',
        'timestampltz',
        'timestampntz',
        'timestamptz',
        'datetime64[ns]',
        'timewithtimezone',
        'timestampwithtimezone',
        'timestamp_with_timezone',
    ].includes(type.toLowerCase());
};
/**
 * @param type
 * @internal
 */
export const isBoolean = (type) => {
    return ['bool', 'boolean', 'bit', 'logical'].includes(type.toLowerCase());
};
/**
 * @param type
 * @internal
 */
export const simpleColumnType = (type) => {
    if (isNumber(type)) {
        return 'number';
    }
    if (isDatetime(type)) {
        return 'datetime';
    }
    if (isText(type)) {
        return 'text';
    }
    if (isBoolean(type)) {
        return 'boolean';
    }
    return 'text';
};
//# sourceMappingURL=simple-column-types.js.map